import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices } from 'premier-capability-hooks';
import AddlInterestTextBoxComponent from "../../components/AddlInterestTextBoxComponent/AddlInterestTextBoxComponent";
import metadata from './LiabilityCoveragesPage.metadata.json5';
import messages from './LiabilityCoveragesPage.messages.js';
import styles from '../../SpaAndWellnessStyles.module.scss';
import CoveragesPage from '../Coverages/CoveragesPage';

function LiabilityCoveragesPage(props) {

    const { wizardData: submissionVM, updateWizardData } = props;
    const { lineName } = PremierConstants;
    const { updateSubmission } = useUpdateSubmissionServices();

    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation
    } = useValidation('LiabilityCoveragesPage');

    const onNext = useCallback(
            async () => {
                const productCode = _.get(submissionVM.value, 'baseData.productCode');
                // eslint-disable-next-line security/detect-object-injection
                const lobLineName = productCode ? lineName[productCode] : '';
                const response = await updateSubmission(lobLineName, 'SpaAndWellnessPage', submissionVM);
    
                submissionVM.value = response;
    
                return submissionVM;
            },
            [lineName, submissionVM, updateSubmission]
        );

    const overrideProps = {
        pswLineCoverageComponent: {
            wizardData: submissionVM,
            updateWizardData,
            clausesBasePath: `lobData.spaAndWellLine.lineCoverages.coverages`,
            clasueType: 'coverages',
            pathToGet: 'spaAndWellLine.coverages'
        },
        additionalInterest: {
            wizardData: submissionVM,
            updateWizardData,
            addlIntPath: 'lobData.spaAndWellLine.coverables.additionalInterests',
            selectedOffering: _.get(submissionVM, 'lobData.value.spaAndWellLine.selectedOffering_Ext'),
            isLiaCov: true
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            coveragespagecomponent: CoveragesPage,
            AddlInterestTextBoxComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata, submissionVM, overrideProps]
    );


    const isDisableNext = () => !_.isUndefined(submissionVM.lobData.spaAndWellLine.coverables.additionalInterests) &&
            !submissionVM.lobData.spaAndWellLine.coverables.additionalInterests.aspects.subtreeValid

    return (
        <WizardPage skipWhen={initialValidation} onNext={onNext} onSave={onNext} disableNext={isDisableNext()} disableSave={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

LiabilityCoveragesPage.propTypes = wizardProps;
export default withRouter(LiabilityCoveragesPage);
